import { render, staticRenderFns } from "./study.vue?vue&type=template&id=1751aaf1&"
import script from "./study.vue?vue&type=script&lang=js&"
export * from "./study.vue?vue&type=script&lang=js&"
import style0 from "./study.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports